import React, { useEffect, useState } from "react";
import "./ScrollButton.scss";
import Logger from "../Logger";
const logger = new Logger();

const ScrollButton = (props: {
  id: string;
  direction: "left" | "right" | "bottom" | "top"; // no itx
}) => {
  const { direction, id } = props;

  const [visible, setVisible] = useState(true);

  function calcVisiblility() {
    const elm = document.getElementById(id) as HTMLElement;
    if (elm) {
      const r = elm.getBoundingClientRect();
      const rParent = (elm.parentElement as HTMLElement)?.getBoundingClientRect();
      const visibleLeft = elm.scrollLeft > 0;
      const visibleRight = elm.scrollWidth - elm.scrollLeft > elm.clientWidth + 10;

      logger.log(`${elm.scrollWidth}  ${elm.scrollLeft}  ${elm.clientWidth}`);

      // elm.style.marginLeft = visibleLeft ? "20px" : "0px";
      // elm.style.marginRight = visibleRight ? "20px" : "0px";

      switch (direction) {
        case "left": // no itx
          setVisible(visibleLeft);
          break;

        case "top": // no itx
          break;

        case "right": // no itx
          setVisible(visibleRight);
          break;

        case "bottom": // no itx
          break;
      }
    }
  }

  useEffect(() => {
    const elm = document.getElementById(id) as HTMLElement;
    if (elm) {
      elm.addEventListener("scroll", calcVisiblility);
    }

    calcVisiblility();
  }, []);

  let top = 0;
  let left = 0;

  let d = 50;

  switch (direction) {
    case "left": // no itx
      left = -d;
      break;

    case "top": // no itx
      top = -d;
      break;
    case "right": // no itx
      left = d;
      break;
    case "bottom": // no itx
      top = d;
      break;
  }

  const scrollToTop = () => {
    const elm = document.getElementById(id);
    elm?.scrollBy({
      top: top,
      left: left,
      behavior: "smooth",
      /* you can also use 'auto' behaviour 
		in place of 'smooth' */
    });
  };

  if (!visible) {
    return null;
  }

  return (
    <div
      className={"ScrollButton " + direction} // no itx
      id={"ScrollButton_" + id + direction}
      onClick={scrollToTop} // no itx
    >
      <div className="ScrollButtonInner">
        <i
          className={"las la-arrow-" + direction} // no itx
        />
      </div>
    </div>
  );
};

export default ScrollButton;
